import { ZfDropdown, ZfDropdownItem } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useYwuApp } from '../../contexts/ywu-app-context';
import { useWealthPlanningNavigate } from '../../hooks/useWealthPlanningNavigate';
import type { AvailableLanguage } from '../../i18n/i18nextInit';
import { AVAILABLE_LANGUAGES } from '../../i18n/i18nextInit';
import { wnSendTrace } from '../../utils/wn-event-utils';

export const LanguageSwitch: FunctionComponent = () => {
    const { i18n } = useTranslation();
    const { activeLanguage, setActiveLanguage } = useYwuApp();
    const { partnerUuid } = useWealthPlanningNavigate();

    const languageOptions = AVAILABLE_LANGUAGES.map((lang) => ({ value: lang, label: lang.toUpperCase() }));

    const handleChangeLanguage = (language: AvailableLanguage) => {
        i18n.changeLanguage(language);
        setActiveLanguage(language);
        wnSendTrace({ feature: 'general', tags: { partnerUuid, action: 'change-language', language } });
    };

    return (
        <ZfDropdown text={activeLanguage} icon="arrow_drop_down" hierarchy="tertiary" size="medium">
            {languageOptions.map((lang) => (
                <ZfDropdownItem
                    state={activeLanguage === lang.value ? 'active' : 'default'}
                    key={lang.value}
                    label={lang.value}
                    onDropdownItemSelect={() => handleChangeLanguage(lang.value)}
                />
            ))}
        </ZfDropdown>
    );
};
